import React from 'react';
import Certificate from '../images/certificates/RPA_Developer_Advanced_Cert.png';
const RPA = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <img
        style={{ maxWidth: '100%', height: 'auto' }}
        src={Certificate}
        alt="RPA Advanced Developer Certificate"
      />
    </div>
  );
};

export default RPA;
